import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./MisionVision.css";
import { FaBullseye, FaEye, FaHandsHelping } from "react-icons/fa";
import visionImg from "../assets/nosotros/mision_vision/fachada.jpg";
import misionImg from "../assets/nosotros/mision_vision/fachada.jpg";
import valoresImg from "../assets/nosotros/mision_vision/fachada.jpg"; 

const MisionVision = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="mision-vision-page">
      {/*  Banner superior */}
      <div className="mv-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Misión, Visión y Valores</h1>
          <p className="lead">
            Comprometidos con la excelencia tecnológica, los valores y el desarrollo humano.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5">
     
        <div className="row align-items-center mb-5" data-aos="fade-right">
          <div className="col-md-6 text-center">
            <img src={visionImg} alt="Visión" className="mv-image" />
          </div>
          <div className="col-md-6">
            <div className="mv-card">
              <FaEye className="mv-icon" />
              <h2 className="section-title">Nuestra Visión</h2>
              <p>
                “Para el año 2032, seremos un Instituto líder en innovación tecnológica, 
                emprendimiento e investigación aplicada, reconocido por aplicar metodologías 
                disruptivas, en base al espíritu de la curiosidad de los estudiantes, 
                para potenciar el pensamiento crítico, la creatividad, el trabajo colaborativo 
                y la resolución de problemas. Con una educación de calidad y alianzas 
                estratégicas con los sectores productivos, formaremos profesionales altamente 
                competitivos, capaces de transformar su entorno y contribuir al desarrollo 
                sostenible del país”.
              </p>
            </div>
          </div>
        </div>

       
        <div className="row align-items-center flex-md-row-reverse mb-5" data-aos="fade-left">
          <div className="col-md-6 text-center">
            <img src={misionImg} alt="Misión" className="mv-image" />
          </div>
          <div className="col-md-6">
            <div className="mv-card">
              <FaBullseye className="mv-icon" />
              <h2 className="section-title">Nuestra Misión</h2>
              <p>
                “Formar profesionales técnicos innovadores y altamente competentes 
                mediante una educación integral basada en competencias, experiencias 
                formativas en contextos reales de trabajo y el fomento de la innovación
                 tecnológica, el emprendimiento y la investigación aplicada. Nuestra 
                 oferta educativa está orientada a responder a las demandas laborales, 
                 fortalecer la competitividad y contribuir al desarrollo sostenible del país”.
              </p>
            </div>
          </div>
        </div>

       
        <div className="row align-items-center mb-5" data-aos="fade-right">
          <div className="col-md-6 text-center">
            <img src={valoresImg} alt="Valores" className="mv-image" />
          </div>
          <div className="col-md-6">
            <div className="mv-card">
              <FaHandsHelping className="mv-icon" />
              <h2 className="section-title">Nuestros Valores</h2>
              <p>
                En el Instituto promovemos los valores que fortalecen nuestra identidad
                institucional y la formación integral de nuestros estudiantes:
              </p>
              <ul className="valores-list text-start mt-3">
                <li>🤝 <strong>Solidaridad</strong></li>
                <li>🏫 <strong>Identidad</strong></li>
                <li>👥 <strong>Trabajo en equipo</strong></li>
                <li>⏰ <strong>Puntualidad</strong></li>
                <li>🙏 <strong>Respeto</strong></li>
                <li>⚖️ <strong>Justicia</strong></li>
                <li>💎 <strong>Honestidad</strong></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MisionVision;

